// Старт заданий: недели идут по 7 суток от этого момента (как QUESTS_START_AT на бэкенде)
export const QUESTS_LAUNCH_AT = Date.parse('2026-09-25T12:00:00Z');
export const WEEK_MS = 7 * 24 * 60 * 60 * 1000;

export const QUEST_TYPES = {
  UPGRADE: 'upgrade',
  INVITE: 'invite',
  INVITE_MULTI: 'invite_multi',
  HOLD: 'hold',
  RECYCLE: 'recycle',
  GOLD_RECYCLE: 'gold_recycle',
  GOLD_TEAM: 'gold_team',
  COMBO: 'combo',
};

export const GOLD_COLOR = '#FFC24B';

export const QUEST_STATUSES = {
  ACTIVE: 'active',
  COMPLETED: 'completed',
  CLAIMED: 'claimed',
};

// 1 = Duo (x2), 2 = Quattro (x4), как в событиях контракта
export const QUEST_PROGRAMS = {
  1: { name: 'Duo', route: '/dashboard/duo', color: '#51F689' },
  2: { name: 'Quattro', route: '/dashboard/quattro', color: '#F1A13B' },
};

export const formatPoints = (value) =>
  Number(value || 0)
    .toLocaleString('en-US')
    .replace(/,/g, ' ');

export const formatTokenAmount = (wei) => formatPoints(Math.ceil(Number(wei || 0) / 1e18));
